import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

const STATUS_LABELS = {
  paid: { label: 'Paid', pill: 'pill-approved' },
  pending: { label: 'Pending', pill: 'pill-pending' },
  failed: { label: 'Failed', pill: 'pill-rejected' },
  expired: { label: 'Expired', pill: 'pill-disabled' },
  refunded: { label: 'Refunded', pill: 'pill-disabled' },
};

export default function OwnerPayments() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get('/owner/payments'); setRows(data.payments || []); }
      catch (e) { setErr(apiError(e)); }
    })();
  }, []);

  return (
    <div data-testid="owner-payments">
      <h2 className="mb-3">Payment history</h2>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead><tr><th>Date</th><th>Business</th><th>Plan</th><th>Amount</th><th>Status</th><th>Session ID</th></tr></thead>
          <tbody>
            {rows.map(r => {
              const st = STATUS_LABELS[r.payment_status] || { label: r.payment_status, pill: 'pill-disabled' };
              return (
                <tr key={r.id} data-testid={`pay-row-${r.id}`}>
                  <td>{new Date(r.created_at).toLocaleString()}</td>
                  <td>{r.business_name || '—'}</td>
                  <td>{r.plan_key}</td>
                  <td>₹ {r.amount}</td>
                  <td><span className={'pill ' + st.pill}>{st.label}</span></td>
                  <td className="small text-muted-2" style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.session_id}</td>
                </tr>
              );
            })}
            {rows.length === 0 && <tr><td colSpan="6" className="text-center py-4 text-muted-2">No payments yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
